export default "__VITE_ASSET__BBkscaeF__"